import {requirePermission} from '@/modules/auth/permissions'
import {useGetInfiniteDrugsCategories} from '@/modules/basic-data/categories/api'
import {DrugsCategoriesFilters, DrugsCategoriesTable} from '@/modules/basic-data/categories/components'
import {DrugsCategoriesSearchSchema} from '@/modules/basic-data/categories/schemas'
import {ResourcesIndexPageHeader} from '@/shared/components/ui/resources-index-page-header'
import {createFileRoute} from '@tanstack/react-router'

export const Route = createFileRoute('/configuration/basic-data/categories/')({
  beforeLoad: requirePermission('basic_data.manage'),
  component: SubstanceCategoriesPage,
  validateSearch: DrugsCategoriesSearchSchema,
})

const LIMIT = 50

function SubstanceCategoriesPage() {
  const search = Route.useSearch()
  const [sort] = search.sort

  const infinite = useGetInfiniteDrugsCategories({
    limit: LIMIT,
    sort: {field: sort.id, dir: sort.desc ? 'desc' : 'asc'},
    filters: {search: search.filters?.search, status: []},
  })

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = infinite

  return (
    <>
      <ResourcesIndexPageHeader addNewTo="/configuration/basic-data/categories/new">
        <DrugsCategoriesFilters />
      </ResourcesIndexPageHeader>

      <DrugsCategoriesTable
        virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}}
        table={{state: {sorting: search.sort}}}
      />
    </>
  )
}
